import { NumberFieldUI } from '@axo/form/feature/form-input/NumberField/NumberFieldUI';
import { MaritalStatus } from '@axo/shared/data-access/types';
import { useTranslation } from '@axo/shared/i18n';
import { Grid } from '@axo/ui-core/components/layout/item';
import { useFormContext } from 'react-hook-form';
import { useAxoFormContext } from '../../../../../../../context/AxoForm/AxoForm';
import { formatSpacedNumber } from '../../../../../../../utils/format';
import { CoApplicantIncomeData } from '../../../../../FormData.fi.types';
import { gridColumns } from '../../../../config/layouts/grid';
import styles from '../../../../loan.module.scss';
import {
  grossIncomeMonthlyFieldOption,
  netIncomeMonthlyFieldOption,
} from './config';

export const CoApplicantIncome = () => {
  const { t } = useTranslation();

  const { register } = useFormContext();
  const { axoFormData } = useAxoFormContext();

  const maritalStatus = axoFormData['LoanApplication/MaritalStatus'];

  const askCoApplicantGrossIncome = maritalStatus === MaritalStatus.Single;

  return (
    // TODO: Fix Style Its jumping due to Two Lines Label and two lines error message
    <Grid columns={gridColumns} className={styles.itemsEnd}>
      {askCoApplicantGrossIncome ? (
        <NumberFieldUI<CoApplicantIncomeData>
          name="Frontend/CoApplicantGrossIncomeMonthly"
          label={t('CoApplicantGrossIncomeMonthly.label')}
          data-testid="gross-income-monthly-input"
          format={formatSpacedNumber}
          suffix={t('suffix.currency')}
          {...grossIncomeMonthlyFieldOption}
        />
      ) : (
        <input
          type="hidden"
          {...register('Frontend/CoApplicantGrossIncomeMonthly', {
            value: axoFormData['Frontend/PartnerGrossIncomeMonthly'],
          })}
        />
      )}

      <NumberFieldUI<CoApplicantIncomeData>
        name="Frontend/CoApplicantNetIncomeMonthly"
        label={t('CoApplicantNetIncomeMonthly.label')}
        data-testid="net-income-monthly-input"
        format={formatSpacedNumber}
        suffix={t('suffix.currency')}
        {...netIncomeMonthlyFieldOption}
      />
    </Grid>
  );
};
